import { Link } from "react-router-dom";
import ContentPage from "../../../Content";

function AddCommercialForms(){
    return (
        <>
            <ContentPage>
            <div class="page-header flex-wrap">
            <div class="header-right d-flex flex-wrap mt-md-2 mt-lg-0">
                <div class="d-flex align-items-center">
                  <a href="#">
                    <p class="m-0 pr-3">Paramètres</p>
                  </a>
                  <a class="pl-3 mr-4" href="#">
                    <p class="m-0">Formulaire de création d'un commercial</p>
                  </a>
                </div>
                {/* <button type="button" class="btn btn-primary mt-2 mt-sm-0 btn-icon-text">
                  <i class="mdi mdi-plus-circle"></i> Add Prodcut </button> */}
              </div>
              <div class="header-left">
                <Link class="btn btn-warning mb-2 mb-md-0 mr-2" to="/parametres/commerciaux"><i class="mdi mdi-backburger"></i> Retour à la liste</Link>
                {/* <button class="btn btn-outline-primary mb-2 mb-md-0"> Import documents </button> */}
              </div>
              
            </div>

            <div class="col-12 grid-margin stretch-card">
                <div class="card">
                  <div class="card-body">
                    <h4 class="card-title">Nouveau commercial</h4>
                    <p class="card-description">Tous les champs sont obligatoires</p>
                    <form class="forms-sample">
                      <div class="form-group">
                        <label for="exampleInputName1">Nom</label>
                        <input type="text" class="form-control" id="exampleInputName1" placeholder="Name" />
                      </div>
                      <div class="form-group">
                        <label for="exampleInputEmail3">Prénoms</label>
                        <input type="email" class="form-control" id="exampleInputEmail3" placeholder="Email" />
                      </div>
                      <div class="form-group">
                        <label for="exampleInputPassword4">Numéro de téléphone</label>
                        <input type="password" class="form-control" id="exampleInputPassword4" placeholder="Password" />
                      </div>
                      <div class="form-group">
                        <label for="exampleSelectGender">Selectionnez un secteur</label>
                        <select class="form-control" id="exampleSelectGender">
                          <option>Male</option>
                          <option>Female</option>
                        </select>
                      </div>
                      {/* <div class="form-group">
                        <label>File upload</label>
                        <input type="file" name="img[]" class="file-upload-default" />
                        <div class="input-group col-xs-12">
                          <input type="text" class="form-control file-upload-info" disabled placeholder="Upload Image" />
                          <span class="input-group-append">
                            <button class="file-upload-browse btn btn-primary" type="button"> Upload </button>
                          </span>
                        </div>
                      </div> */}
                      <div class="form-group">
                        <label for="exampleInputCity1">Code Distriforce</label>
                        <input type="text" class="form-control" id="exampleInputCity1" placeholder="Location" />
                      </div>
                      {/* <div class="form-group">
                        <label for="exampleTextarea1">Description</label>
                        <textarea
                          class="form-control"
                          id="exampleTextarea1"
                          rows="4"
                        ></textarea>
                      </div> */}
                      <button type="submit" class="btn btn-primary mr-2"> Submit </button>
                      <button class="btn btn-light">Cancel</button>
                    </form>
                  </div>
                </div>
              </div>
            </ContentPage>
        </>
    )
}

export default AddCommercialForms;